export { default as RewardLockIcon } from './reward-lock-icon';
